import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_ADD_TOWN, ROUTE_TOWN, ROUTE_UPDATE_TOWN} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Town = lazy(() =>
  import('../../../screens/Town')
    .then(module => ({default: module.Town})));

const AddTown = lazy(() =>
  import('../../../screens/Town')
    .then(module => ({default: module.AddTown})));

const EditTown = lazy(() =>
  import('../../../screens/Town')
    .then(module => ({default: module.EditTown})));

const TownNavigation = [
  {
    path: ROUTE_TOWN,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Town />
      </Suspense>
    ),
  },
  {
    path: ROUTE_ADD_TOWN,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <AddTown />
      </Suspense>
    ),
  },
  {
    path: ROUTE_UPDATE_TOWN,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <EditTown />
      </Suspense>
    ),
  },
];

export default TownNavigation;
